/**
 * De bannergegevens van "Geen klant gevonden", als losse haak.
 *
 * Eigen bestand naast `KoppelBanner.tsx`: een bestand dat zowel een
 * component als een haak uitvoert breekt fast refresh, en dat is precies
 * het soort kleine slijtage dat je later niet meer terugvindt.
 *
 * De middenkolom gebruikt hem om te weten óf de banner er staat: dan
 * laat hij zijn eigen "Geen klant gevonden"-balk weg (JP, punt 21 van
 * 22-09). Dezelfde sleutel als de banner zelf, dus react-query deelt het
 * antwoord en er gaat geen tweede aanroep uit.
 */
import { useQuery } from "@tanstack/react-query";

import { werkplekKoppelingApi } from "@/lib/werkplek-api";

export function useKoppelBanner(zaakId: string | null) {
  return useQuery({
    queryKey: ["werkplek", "koppeling", zaakId],
    queryFn: () => werkplekKoppelingApi.banner(zaakId as string),
    enabled: Boolean(zaakId),
  });
}
